import * as React from "react";
import { Anchor } from "../../typography/anchor/anchor.mjs";
import { Container } from "../../container/container.mjs";
import { Grid } from "../../grid/grid/grid.mjs";
import { GridColumn } from "../../grid/grid-column/grid-column.mjs";
import { Icon } from "../../icon/icon/icon.mjs";
import { Image } from "../../image/image.mjs";
import { List } from "../../list/list/list.mjs";
import { ListItem } from "../../list/list-item/list-item.mjs";
import { Tag } from "../../tag/tag.mjs";
import { ThemeContext } from "../../helpers/theme-provider/theme-provider.mjs";
import { HeaderMegamenuBanner } from "../header-megamenu-banner/header-megamenu-banner.mjs";
const _HeaderMegamenu = class _HeaderMegamenu extends React.PureComponent {
  constructor(props) {
    super(props);
    this.renderListTitle = (titleProps, titleId) => {
      const titleBEM = (hasTag) => {
        const classArray = ["h4 text-bold header__megamenu-title"];
        if (hasTag) {
          classArray.push("header__megamenu-title--no-margin");
        }
        return classArray.join(" ");
      };
      const getTitle = (label, hasTag) => {
        return /* @__PURE__ */ React.createElement("div", { className: titleBEM(hasTag), id: titleId }, label);
      };
      if (typeof titleProps === "string") {
        return getTitle(titleProps);
      } else if (titleProps.tag) {
        return /* @__PURE__ */ React.createElement(Grid, { verticalGutter: "none", horizontalGutter: "small" }, /* @__PURE__ */ React.createElement(GridColumn, { width: ["xs", "lg-12"] }, getTitle(titleProps.title, true)), /* @__PURE__ */ React.createElement(GridColumn, { width: ["xs", "lg-12"] }, /* @__PURE__ */ React.createElement(Tag, { ...titleProps.tag, className: "header__megamenu-title-tag" })));
      } else {
        return getTitle(titleProps.title);
      }
    };
    this.renderList = (list, listIndex, columnId) => {
      const listId = list.id || listIndex;
      const titleId = this.generateTitleId(columnId, listId);
      return /* @__PURE__ */ React.createElement("div", { className: "header__megamenu-section", key: listId }, list.title && this.renderListTitle(list.title, titleId), /* @__PURE__ */ React.createElement(
        List,
        {
          className: this.ListBEM(list),
          type: list.items.some((item) => item.icon) ? "icon" : "unstyled",
          fullWidth: true,
          iconPosition: "middle",
          "aria-labelledby": list.title ? titleId : void 0
        },
        this.renderListItems(list.items)
      ));
    };
    this.handleResize = () => {
      var _a;
      const isMobile = window.matchMedia("(max-width: ".concat(this.context.media.width.md.max, ")")).matches;
      const refElementRect = (_a = this.props.reference) == null ? void 0 : _a.getBoundingClientRect();
      const container = this.props.id && document.getElementById(this.props.id);
      const containerRect = container && container.getBoundingClientRect();
      const containerLeft = containerRect && containerRect.left;
      const refElementLeft = refElementRect && containerLeft && refElementRect.left - containerLeft;
      const containerRight = containerRect && containerLeft && containerRect.right - containerLeft;
      if (typeof refElementLeft === "number") {
        this.setState({
          refElementLeft
        });
      }
      if (typeof containerRight === "number") {
        this.setState({
          containerRight
        });
      }
      if (this.state.isMounted && this.state.isMobile !== isMobile) {
        this.setState({
          isMobile
        });
      }
    };
    this.state = {
      refElementLeft: void 0,
      containerRight: void 0,
      isMobile: void 0,
      isMounted: false
    };
  }
  componentDidMount() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    const isMobile = window.matchMedia("(max-width: ".concat(this.context.media.width.md.max, ")")).matches;
    this.setState({
      isMounted: true,
      isMobile
    });
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }
  BEM() {
    const classArray = ["header__megamenu"];
    if (this.props.className) {
      classArray.push(this.props.className);
    }
    return classArray.join(" ");
  }
  linkBEM(item) {
    const classArray = ["header__megamenu-link"];
    if (item.isCurrent) {
      classArray.push("is-current");
    }
    if (item.color === "employee") {
      classArray.push("header__megamenu-link--employee");
    }
    return classArray.join(" ");
  }
  renderListLink(item) {
    const { isExternal, isSecure, image, label, tag, icon, isCurrent, ...rest } = item;
    return /* @__PURE__ */ React.createElement(
      Anchor,
      {
        isUnderlined: false,
        ...rest,
        className: this.linkBEM(item),
        attributes: {
          ...rest.attributes,
          "aria-current": isCurrent ? "page" : void 0
        }
      },
      /* @__PURE__ */ React.createElement("div", { className: "header__megamenu-link-inner" }, /* @__PURE__ */ React.createElement(Grid, { noWrap: true, gutter: "none" }, !!icon && /* @__PURE__ */ React.createElement(GridColumn, { width: ["min"] }, /* @__PURE__ */ React.createElement(Icon, { ...icon, size: "xs", align: "middle", className: "header__nav-item-icon" })), /* @__PURE__ */ React.createElement(GridColumn, { width: icon ? ["max"] : void 0 }, label, typeof isSecure !== "undefined" && /* @__PURE__ */ React.createElement(Icon, { modifiers: isSecure ? "#lock" : "#lock-open", className: "header__megamenu-link-secure-icon", align: "middle" }), isExternal && /* @__PURE__ */ React.createElement(Icon, { modifiers: "#new-window", className: "header__megamenu-external-icon", align: "middle" })))),
      tag && /* @__PURE__ */ React.createElement(Tag, { ...tag, size: "tiny", className: "header__megamenu-tag" }),
      image && /* @__PURE__ */ React.createElement(Image, { ...image, className: "header__megamenu-link-image" })
    );
  }
  renderListItems(items) {
    return items.map((item, index) => {
      return /* @__PURE__ */ React.createElement(ListItem, { key: item.id || index, className: "header__megamenu-list-item" }, this.renderListLink(item));
    });
  }
  ListBEM(list) {
    const classArray = ["header__megamenu-list"];
    if (list.hasBorder) {
      classArray.push("header__megamenu-list--bordered");
    }
    return classArray.join(" ");
  }
  generateTitleId(columnId, listId) {
    if (this.props.id) {
      return "".concat(this.props.id, "-id-").concat(columnId, "-").concat(listId);
    }
    return "header__megamenu-title-id-".concat(columnId, "-").concat(listId);
  }
  columnBEM(column) {
    const classArray = ["header__megamenu-column"];
    if (column.hasBorder) {
      classArray.push("header__megamenu-column--bordered");
    }
    return classArray.join(" ");
  }
  renderColumns() {
    return this.props.columns.map((column, columnIndex) => {
      const columnId = column.id || columnIndex;
      return /* @__PURE__ */ React.createElement("div", { key: columnId, className: this.columnBEM(column) }, column.lists.map((list, listIndex) => {
        return this.renderList(list, listIndex, columnId);
      }));
    });
  }
  renderBanner(banner, count, index) {
    const width = count === 2 ? ["xs-12", "lg-6"] : ["xs-12"];
    return /* @__PURE__ */ React.createElement(GridColumn, { width, key: index, className: "header__megamenu-banners-grid-col" }, /* @__PURE__ */ React.createElement(HeaderMegamenuBanner, { ...banner }));
  }
  renderBannersGrid(banners) {
    return /* @__PURE__ */ React.createElement(Grid, { equalHeight: true, className: "header__megamenu-banners-grid" }, banners.map((item, index) => this.renderBanner(item, banners.length, index)));
  }
  renderBanners(banners) {
    return /* @__PURE__ */ React.createElement("div", { className: "header__megamenu-banners" }, this.isBannerPropsArray(banners) ? this.renderBannersGrid(banners) : banners);
  }
  isBannerPropsArray(banners) {
    return Array.isArray(banners);
  }
  getMegamenuStyles() {
    var _a, _b;
    const refElementRect = (_a = this.props.reference) == null ? void 0 : _a.getBoundingClientRect();
    const container = this.props.id && document.getElementById(this.props.id);
    const containerRect = container && container.getBoundingClientRect();
    const containerLeft = containerRect && containerRect.left;
    const refElementLeft = refElementRect && containerLeft && refElementRect.left - containerLeft;
    const refComputedStyle = this.props.reference && getComputedStyle(this.props.reference);
    const refElementLeftWithPadding = refElementLeft && refComputedStyle && refElementLeft + parseFloat(refComputedStyle.paddingLeft);
    const gridColumns = container && ((_b = container.firstElementChild) == null ? void 0 : _b.children);
    let gridColumnsWidth = 0;
    if (gridColumns) {
      gridColumnsWidth = Object.values(gridColumns).reduce((total, i) => total + i.offsetWidth, 0);
    }
    const distanceFromRefLeftToContainerRight = this.state.containerRight && this.state.refElementLeft && this.state.containerRight - this.state.refElementLeft;
    if (this.props.columns.length > 4) {
      return { width: "100%" };
    } else if (distanceFromRefLeftToContainerRight && distanceFromRefLeftToContainerRight < gridColumnsWidth) {
      return { width: "100%", justifyContent: "flex-end" };
    } else if (refElementLeftWithPadding) {
      return {
        transform: "translate(".concat(refElementLeftWithPadding, "px, 0)")
      };
    }
  }
  render() {
    const megamenu = (styles) => /* @__PURE__ */ React.createElement("div", { className: this.BEM(), id: this.props.id }, /* @__PURE__ */ React.createElement("div", { className: "header__megamenu-grid", style: styles }, this.renderColumns()), this.props.banners && this.renderBanners(this.props.banners));
    if (!this.state.isMobile) {
      return /* @__PURE__ */ React.createElement(Container, null, megamenu(this.getMegamenuStyles()));
    } else {
      return megamenu();
    }
  }
};
_HeaderMegamenu.contextType = ThemeContext;
let HeaderMegamenu = _HeaderMegamenu;
export {
  HeaderMegamenu
};
